import { render, staticRenderFns } from "./workerJobTitleCurrent.vue?vue&type=template&id=470e6137&"
import script from "./workerJobTitleCurrent.vue?vue&type=script&lang=js&"
export * from "./workerJobTitleCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports